import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
  timeout: 60000,
});

/**
 * Upload intake form photo and get extracted fields back.
 * POST /api/intake/extract
 * @param {File} imageFile
 * @returns {Promise<{ extracted: Object, warnings: string[] }>}
 */
export async function extractIntakeData(imageFile) {
  const formData = new FormData();
  formData.append('image', imageFile);

  const response = await api.post('/api/intake/extract', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
}
